// Постраничная разметка перенесена в features/pages («Разметка страницы»: листы A4, построчный перенос, номера
// страниц). Здесь - совместимость для холста: подписка на смену масштаба, режима и листов перед текстом.
import { useEffect } from 'react';
import { useApp } from '../../core/store';
import { useUi } from '../../ui/uiState';
import { relayout } from '../pages/plugin';
import { usePages } from '../pages/store';

/** Пересчитать разметку при смене масштаба, режима «Разметка страницы», метаданных и листов перед текстом. */
export function usePagination(_sheetRef?: React.RefObject<HTMLDivElement | null>) {
  const editor = useApp((s) => s.editor);
  const zoom = useApp((s) => s.zoom);
  const meta = useApp((s) => s.meta);
  const show = useUi((s) => s.showPages);
  const front = usePages((s) => s.frontCount);
  useEffect(() => {
    if (!editor || editor.isDestroyed) return;
    const t = requestAnimationFrame(() => relayout(editor.view));
    return () => cancelAnimationFrame(t);
  }, [editor, zoom, meta, show, front]);
}

/** Прежние пунктирные границы страниц больше не рисуются: страницы - настоящие листы (PagesLayer). */
export function PageMarks() { return null; }
